import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import React from "react";
import DeliveryModal from "./DeliveryModal";
import { useState } from "react";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";

export default function DeliveryItem({ data }) {
    const [showModal, setShowModal] = useState(false);

    return (
        <div>

            <div className="block block-rounded block-fx-pop block-bordered" onClick={() => setShowModal(!showModal)}>
                <div className="block-header block-header-default">
                    <div className="block-title">
                        <small>{Translate(Message.DeliveryCode)}</small><br />
                        {data && data.awb != undefined && data.awb != null ? data.awb : data.id}
                    </div>
                    <div className="block-tools">{data && DeliveryHelper().Status(data.status)}</div>
                </div>
                <div className="block-content">
                    <ul class="timeline timeline-alt mt-2 mb-2">
                        <li className="timeline-event mt-2 mb-2">
                            <div class="media py-2">
                                <div className="mr-5 overlay-container overlay-left">
                                    <span className="overlay-item item  item-circle border border-2x border-white timeline-event-icon bg-success">
                                        <i className="si si-pin" />
                                    </span>
                                </div>
                                <div className="media-body ml-2 mb-3 row">
                                    <span className="col-12">
                                        <b>{data && data.origin && `${data.origin.number}, ${data.origin.street}, ${data.origin.neighborhood}`}</b>
                                        <br />
                                        <small>{data && data.origin && `${data.origin.city} - ${data.origin.state}`}</small>
                                    </span>
                                    <span className="col-2 text-right">
                                        {/* <button
                                            className="btn btn-sm btn-dual" onClick={() => toggleCard()}
                                            >
                                                <i className={`si si-arrow-${open === true ? "up" : "down"}`}></i>
                                        </button> */}
                                    </span>
                                </div>
                            </div>
                        </li>
                        <li className="timeline-event mt-2 mb-2">
                            <div class="media py-2">
                                <div className="mr-5 overlay-container overlay-left">
                                    <span className="overlay-item item  item-circle border border-2x border-white timeline-event-icon bg-success">
                                        <i className="fa fa-map-marker-alt" />
                                    </span>
                                </div>
                                <div className="media-body ml-2 mb-3 row">
                                    <span className="col-12">
                                        <b>{data && data.destination && `${data.destination.number}, ${data.destination.street}, ${data.destination.neighborhood}`}</b>
                                        <br />
                                        <small>{data && data.destination && `${data.destination.city} - ${data.destination.state}`}</small>
                                    </span>
                                    <span className="col-6 text-right">
                                        {/* <button
                                            className="btn btn-sm btn-dual" onClick={() => toggleCard()}
                                            >
                                                <i className={`si si-arrow-${open === true ? "up" : "down"}`}></i>
                                        </button> */}
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <DeliveryModal
                deliveryId={data && data.id}
                show={showModal}
                onHide={() => setShowModal(!showModal) | console.log("Feshou", showModal)}
            />
        </div>
    )
}